import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { FreightOrderDialog } from 'src/modules/supply_chain/components/freight/OrderDialog'
import { skuit } from 'src/services/skuit'

import { FreightOrderListTable } from 'src/components/Table/list/FreightOrder'
import { ListPage } from 'src/components/Pages/ListPage'

export const OrderListPage = () => {
  const paginator = useQueryPaginator('freight-order-list', skuit.sc.freight.orders.list)

  return (
    <ListPage
      title="Freight Orders"
      paginator={paginator}
      dialogs={[{ title: 'New Freight Order', Dialog: FreightOrderDialog }]}
    >
      <FreightOrderListTable
        paginator={paginator}
        fields={[
          'number',
          'client',
          'placedOn',
          'fulfillOn',
          'cannotShipBefore',
          'mustShipBy',
          'expectedShipDate',
          'mustCancelBy',
          'retailer',
          'consignee',
          'status',
          'flags',
          'customFields',
          'nextAppointment',
        ]}
        bulkActions={[
          'printOrder',
          'printPickTicket',
          'printAll',
          'printPlacard',
          'divider',
          'bulkEdit',
          'divider',
          'status',
          'cancel',
        ]}
      />
    </ListPage>
  )
}
